/* RESPONSIBLE TEAM: team-ai-insights */
import ApplicationAdapter from '../application';
import { inject as service } from '@ember/service';
import type ReportingChartService from 'embercom/services/reporting-chart-service';

export default class ContentSnippetAdapter extends ApplicationAdapter {
  @service declare reportingChartService: ReportingChartService;

  ajax(url: string, type: string, options: any = {}) {
    if (!options.data) {
      options = Object.assign(options, { data: {} });
    }

    // Add synthetic data parameter if in synthetic mode
    if (this.reportingChartService.syntheticDataUseCase) {
      options.data.synthetic_data_use_case = this.reportingChartService.syntheticDataUseCase;
    }

    return super.ajax(url, type, options);
  }
}
